var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading"}},[_c('span',{staticClass:"loading__content"},[_c('span',{staticClass:"loading__content__spinner"},[_c('Spinner')],1),_c('span',{staticClass:"loading__content__text"},[_vm._v(" "+_vm._s(_vm.$t('common.is_loading'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }